/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    const mobile = window.matchMedia('(max-width: 767px)');
    const root = document.documentElement;
    let scrollPosition = 0;

    function closeMenu() {
        if (!navigation.classList.contains('is-open')) return;

        navigation.classList.remove('is-open');
        root.classList.remove('gh-navigation-open');
        root.style.removeProperty('--gh-navigation-scroll-top');
        window.scrollTo({top: scrollPosition, behavior: 'instant'});
    }

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            if (!mobile.matches) return;

            scrollPosition = window.scrollY;
            root.style.setProperty('--gh-navigation-scroll-top', `${-scrollPosition}px`);
            root.classList.add('gh-navigation-open');
            navigation.classList.add('is-open');
        } else {
            closeMenu();
        }
    });

    mobile.addEventListener('change', function () {
        if (!mobile.matches) closeMenu();
    });
})();

/* Add lightbox to gallery and feature images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img, .gh-feature-image'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();

/* Spread: norske feilmeldinger i påmeldingsskjemaet på forsiden */
(function () {
    const errorFields = document.querySelectorAll('.spread-form [data-members-error]');

    function toNorwegian(message) {
        if (/too many/i.test(message)) return 'For mange forsøk. Prøv igjen senere.';
        if (/restricted|domain/i.test(message)) return 'Påmelding fra dette e-postdomenet er ikke tillatt.';
        if (/valid|invalid/i.test(message)) return 'Skriv inn en gyldig e-postadresse.';
        return 'Noe gikk galt. Sjekk e-postadressen og prøv igjen.';
    }

    errorFields.forEach(function (field) {
        let written = '';

        new MutationObserver(function () {
            const current = field.textContent.trim();
            if (!current || current === written) return;

            written = toNorwegian(current);
            field.textContent = written;
        }).observe(field, {childList: true, characterData: true, subtree: true});
    });
})();

/* Spread: rolig innfading av seksjonene på forsiden når man scroller */
(function () {
    const sections = document.querySelectorAll('[data-spread-reveal]');
    if (!sections.length || !('IntersectionObserver' in window)) return;

    document.documentElement.classList.add('spread-js');

    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
        });
    }, {threshold: 0.15, rootMargin: '0px 0px -6% 0px'});

    sections.forEach(function (section) {
        observer.observe(section);
    });
})();

/* Spread: 3D-vindu med automatisk scrolling for nyhetsbrev-eksempelet */
(function () {
    const stage = document.querySelector('[data-spread-stage]');
    if (!stage) return;

    const scroller = stage.querySelector('.spread-scroller');
    const fit = stage.querySelector('.spread-email-fit');
    const email = stage.querySelector('.spread-email');
    const tilt = stage.querySelector('.spread-tilt');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const hasMouse = window.matchMedia('(hover: hover) and (pointer: fine)');

    const EMAIL_WIDTH = 600;
    const BASE_RX = 8;
    const BASE_RY = -12;
    const TILT_RANGE = 6;
    const SCROLL_SECONDS = 70;
    const HOLD_SECONDS = 2;
    const RETURN_SECONDS = 3;

    /* Skalerer e-posten (fast 600 px) så den passer i vinduet */
    function fitEmail() {
        const scale = Math.min(1, scroller.clientWidth / EMAIL_WIDTH);
        email.style.transform = scale < 1 ? 'scale(' + scale + ')' : '';
        fit.style.height = email.offsetHeight * scale + 'px';
    }

    fitEmail();
    if ('ResizeObserver' in window) {
        new ResizeObserver(fitEmail).observe(scroller);
        new ResizeObserver(fitEmail).observe(email);
    } else {
        window.addEventListener('resize', fitEmail);
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitEmail);

    if (reduceMotion.matches || !('IntersectionObserver' in window)) return;

    /* Automatisk scrolling */
    let state = 'top';
    let elapsed = 0;
    let position = 0;
    let returnFrom = 0;
    let paused = false;
    let lastTime = 0;
    let frame = 0;

    function maxScroll() {
        return scroller.scrollHeight - scroller.clientHeight;
    }

    function resume() {
        position = scroller.scrollTop;
        elapsed = 0;
        const max = maxScroll();
        state = position <= 1 ? 'top' : position >= max - 1 ? 'bottom' : 'down';
        paused = false;
    }

    function tick(now) {
        frame = requestAnimationFrame(tick);
        const dt = Math.min(now - lastTime, 64) / 1000;
        lastTime = now;
        if (paused) return;

        const max = maxScroll();
        if (max <= 0) return;

        if (state === 'top') {
            elapsed += dt;
            if (elapsed >= HOLD_SECONDS) { state = 'down'; elapsed = 0; }
        } else if (state === 'down') {
            position = Math.min(position + (max / SCROLL_SECONDS) * dt, max);
            scroller.scrollTop = position;
            if (position >= max) { state = 'bottom'; elapsed = 0; }
        } else if (state === 'bottom') {
            elapsed += dt;
            if (elapsed >= HOLD_SECONDS) { state = 'back'; elapsed = 0; returnFrom = position; }
        } else {
            elapsed += dt;
            const p = Math.min(elapsed / RETURN_SECONDS, 1);
            const eased = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
            position = returnFrom * (1 - eased);
            scroller.scrollTop = position;
            if (p >= 1) { state = 'top'; elapsed = 0; position = 0; }
        }
    }

    function start() {
        if (frame) return;
        lastTime = performance.now();
        frame = requestAnimationFrame(tick);
    }

    function stop() {
        cancelAnimationFrame(frame);
        frame = 0;
    }

    new IntersectionObserver(function (entries) {
        const visible = entries[0].isIntersecting;
        stage.classList.toggle('is-active', visible);
        if (visible) start(); else stop();
    }, {threshold: 0.2}).observe(stage);

    /* Mus: pause, vipp mot pekeren og la brukeren scrolle selv */
    function setTilt(rx, ry) {
        tilt.style.setProperty('--rx', rx + 'deg');
        tilt.style.setProperty('--ry', ry + 'deg');
    }

    stage.addEventListener('pointermove', function (event) {
        if (event.pointerType !== 'mouse' || !hasMouse.matches) return;
        const rect = tilt.getBoundingClientRect();
        const nx = Math.max(-1, Math.min(1, (event.clientX - rect.left) / rect.width * 2 - 1));
        const ny = Math.max(-1, Math.min(1, (event.clientY - rect.top) / rect.height * 2 - 1));
        setTilt((BASE_RX - ny * TILT_RANGE).toFixed(2), (BASE_RY + nx * TILT_RANGE).toFixed(2));
    });

    stage.addEventListener('pointerenter', function (event) {
        if (event.pointerType === 'mouse') paused = true;
    });

    stage.addEventListener('pointerleave', function (event) {
        if (event.pointerType !== 'mouse') return;
        setTilt(BASE_RX, BASE_RY);
        resume();
    });

    /* Mobil: et trykk pauser og et nytt trykk fortsetter. Egen scrolling pauser også. */
    scroller.addEventListener('click', function () {
        if (hasMouse.matches) return;
        if (paused) resume(); else paused = true;
    });

    scroller.addEventListener('touchmove', function () {
        paused = true;
    }, {passive: true});
})();
